import CountryStateCitySelector from "../../../shared/common/CountryStateCitySelector";
import AutocompleteField from "../../../shared/forms/AutocompleteField";
import FullWidthHobbiesGrid from "../../../shared/components/FullWidthHobbiesGrid";

import {
  brideGroomCategoryOptions,
  charanaPadaOptions,
  heightFeetOptions,
  heightInchOptions,
  maritalStatusOptions,
  subCasteOptions,
} from "../../../shared/config/profileOptions";

import {
  getOptionLabel,
} from "../../../shared/forms/optionUtils";

const inputClass =
  "mt-1 block w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20";

const Field = ({
  label,
  required = false,
  children,
}) => (
  <label className="block text-sm font-medium text-slate-700">
    <span>
      {label}
      {required && (
        <span className="ml-1 text-red-600">*</span>
      )}
    </span>
    {children}
  </label>
);

const PersonalDetailsSection = ({
  formData,
  updateField,
  setFieldValue,
  gotraOptions,
  rashiOptions,
  nakshatraOptions,
  searchGuruMatha,
  searchPlaces,
}) => (
  <div className="space-y-6">
    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
      <Field
        label="Marital Status"
        required
      >
        <select
          name="marriedStatus"
          value={formData.marriedStatus}
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select
          </option>
          {maritalStatusOptions.map(
            (option) => (
              <option
                key={option.value}
                value={option.value}
              >
                {option.label}
              </option>
            )
          )}
        </select>
      </Field>

      <Field label="Height" required>
        <div className="grid grid-cols-2 gap-2">
          <select
            name="heightFeet"
            value={formData.heightFeet}
            onChange={updateField}
            className={inputClass}
          >
            <option value="">
              Feet
            </option>
            {heightFeetOptions.map(
              (option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              )
            )}
          </select>

          <select
            name="heightInches"
            value={formData.heightInches}
            onChange={updateField}
            className={inputClass}
          >
            <option value="">
              Inches
            </option>
            {heightInchOptions.map(
              (option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              )
            )}
          </select>
        </div>
      </Field>

      <Field
        label="Bride/Groom Category"
        required
      >
        <select
          name="profileCategory"
          value={formData.profileCategory || ""}
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select Category
          </option>
          {brideGroomCategoryOptions.map(
            (option) => (
              <option
                key={option.value}
                value={option.value}
              >
                {option.label}
              </option>
            )
          )}
        </select>
      </Field>

      <AutocompleteField
        label="Native Place"
        value={formData.nativePlace}
        searchFn={searchPlaces}
        placeholder="Start typing native place"
        onChange={(value) =>
          setFieldValue(
            "nativePlace",
            value
          )
        }
      />

      <Field label="Time of Birth">
        <input
          type="time"
          name="timeOfBirth"
          value={
            String(
              formData.timeOfBirth || ""
            ).slice(0, 5)
          }
          onChange={updateField}
          className={inputClass}
        />
      </Field>
    </div>

    <div className="grid gap-4 md:grid-cols-3">
      <CountryStateCitySelector
        formData={formData}
        handleChange={updateField}
        countryField="placeOfBirthCountry"
        stateField="placeOfBirthState"
        cityField="placeOfBirth"
        labelPrefix="Place of Birth"
      />
    </div>

    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
      <Field label="Gotra" required>
        <select
          name="gotra"
          value={formData.gotra || ""}
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select Gotra
          </option>
          {(gotraOptions || []).map(
            (option, index) => {
              const label =
                getOptionLabel(option);
              return (
                <option
                  key={`${label}-${index}`}
                  value={label}
                >
                  {label}
                </option>
              );
            }
          )}
        </select>
      </Field>

      <Field label="Rashi" required>
        <select
          name="rashi"
          value={formData.rashi || ""}
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select Rashi
          </option>
          {(rashiOptions || []).map(
            (option, index) => {
              const label =
                getOptionLabel(option);
              return (
                <option
                  key={`${label}-${index}`}
                  value={label}
                >
                  {label}
                </option>
              );
            }
          )}
        </select>
      </Field>

      <Field
        label="Nakshatra"
        required
      >
        <select
          name="nakshatra"
          value={
            formData.nakshatra || ""
          }
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select Nakshatra
          </option>
          {(nakshatraOptions || []).map(
            (option, index) => {
              const label =
                getOptionLabel(option);
              return (
                <option
                  key={`${label}-${index}`}
                  value={label}
                >
                  {label}
                </option>
              );
            }
          )}
        </select>
      </Field>

      <Field
        label="Charana Pada"
        required
      >
        <select
          name="charanaPada"
          value={
            formData.charanaPada || ""
          }
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select
          </option>
          {charanaPadaOptions.map(
            (option) => (
              <option
                key={option.value}
                value={option.value}
              >
                {option.label}
              </option>
            )
          )}
        </select>
      </Field>

      <Field
        label="Sub Caste"
        required
      >
        <select
          name="subCaste"
          value={formData.subCaste || ""}
          onChange={updateField}
          className={inputClass}
        >
          <option value="">
            Select
          </option>
          {subCasteOptions.map(
            (option) => (
              <option
                key={option.value}
                value={option.value}
              >
                {option.label}
              </option>
            )
          )}
        </select>
      </Field>

      <AutocompleteField
        label="Guru Matha"
        required
        value={formData.guruMatha}
        searchFn={searchGuruMatha}
        placeholder="Start typing Guru Matha"
        onChange={(value) =>
          setFieldValue(
            "guruMatha",
            value
          )
        }
      />

      <div className="md:col-span-2 lg:col-span-3">
        <FullWidthHobbiesGrid
          label="Hobbies"
          fieldName="hobbies"
          formData={formData}
          handleChange={(event) =>
            setFieldValue(
              "hobbies",
              event.target.value
            )
          }
        />
      </div>
    </div>
  </div>
);

export default PersonalDetailsSection;